const SET_USER_TABLE = (state, payload) => {
    state.user_table = payload.data
}

export {
    SET_USER_TABLE,
}